/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductDimensionService = {
  /**
   * Get Screen data
   *
   * */
  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/ProductUnitOfMeasureDimension",
      expand: "Product($select=Code,Description1,UnitOfMeasureCode,IsKit)", // ,BinLocation($select=Code,Location),Branch($select=Code,Description)
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    // eslint-disable-next-line no-debugger

    return ApiService.createDataSource(url, params);
  },
  async save(mode, productDimension) {
    var payload = productDimension;
    var url = "api/ProductUnitOfMeasureDimension";

    return await ApiService.patch(
      url,
      productDimension.RecordId,
      payload,
      "Guid"
    );
  },
};

export { ProductDimensionService };
